<template>
  <v-card class="step-confirm" rounded="xl" elevation="0">
    <v-card-text class="pa-6 pa-md-8">
      <div class="step-confirm__badge">
        {{ context.completed ? "Завершено" : "Состояние сохранено" }}
      </div>
      <h3 class="step-confirm__title">
        {{ context.completed ? "Импорт обработан" : "Пакет решений сохранён" }}
      </h3>
      <p class="step-confirm__description">
        {{ descriptionText }}
      </p>

      <v-row class="mt-2">
        <v-col cols="12" md="4">
          <v-sheet class="step-confirm__metric" rounded="xl">
            <div class="step-confirm__metric-value">{{ context.sourceRecordCount || context.uploadedLessons || 0 }}</div>
            <div class="step-confirm__metric-label">Найдено записей в файле</div>
          </v-sheet>
        </v-col>
        <v-col cols="12" md="4">
          <v-sheet class="step-confirm__metric" rounded="xl">
            <div class="step-confirm__metric-value">{{ context.importedCount || 0 }}</div>
            <div class="step-confirm__metric-label">Импортировано записей</div>
          </v-sheet>
        </v-col>
        <v-col cols="12" md="4">
          <v-sheet class="step-confirm__metric" rounded="xl">
            <div class="step-confirm__metric-value">{{ context.skippedCount || 0 }}</div>
            <div class="step-confirm__metric-label">Пропущено записей</div>
          </v-sheet>
        </v-col>
      </v-row>

      <div class="mt-6 d-flex flex-wrap ga-3">
        <v-btn color="primary" size="large" @click="$emit('restart')">
          Загрузить новый файл
        </v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "StepConfirm",
  props: {
    context: {
      type: Object,
      required: true,
    },
  },
  computed: {
    descriptionText() {
      if (this.context.completed) {
        return "Все найденные конфликты обработаны. Текущий импорт больше не требует вмешательства.";
      }

      return "Выбранные решения сохранены. Можно вернуться к новому импорту или продолжить обработку позже.";
    },
  },
};
</script>

<style scoped>
.step-confirm {
  border: 1px solid rgba(15, 23, 42, 0.08);
  background:
    radial-gradient(circle at top left, rgba(74, 222, 128, 0.12), transparent 24%),
    linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
}

.step-confirm__badge {
  display: inline-flex;
  padding: 6px 10px;
  border-radius: 999px;
  background: rgba(34, 197, 94, 0.14);
  color: #15803d;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin-bottom: 14px;
}

.step-confirm__title {
  font-size: 30px;
  line-height: 1.12;
  margin: 0 0 12px;
  color: #0f172a;
}

.step-confirm__description {
  margin: 0;
  max-width: 720px;
  font-size: 16px;
  line-height: 1.65;
  color: #475569;
}

.step-confirm__metric {
  padding: 18px;
  border: 1px solid rgba(15, 23, 42, 0.06);
  background: rgba(255, 255, 255, 0.9);
}

.step-confirm__metric-value {
  font-size: 32px;
  font-weight: 800;
  color: #0f172a;
  line-height: 1;
}

.step-confirm__metric-label {
  margin-top: 8px;
  color: #64748b;
}
</style>
